export default __webpack_public_path__ + "static/media/logo-dna-2.debbf3b7.svg";